// removed by extract-text-webpack-plugin
module.exports = {"root":"kits--root--2OtWRUx5 home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","grid-container":"kits--grid-container--3fZBR_iH home--grid-container--3c3JLjRI","gridContainer":"kits--grid-container--3fZBR_iH home--grid-container--3c3JLjRI","form-container":"kits--form-container--_5INX48u home--message--9FSspPIv","formContainer":"kits--form-container--_5INX48u home--message--9FSspPIv","title":"kits--title--3CoilZL6 crops--title--3nbOw3vq","reminder":"kits--reminder--2D2w-3nW"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/rti-multiplier/kits/styles.css
// module id = ./views/refunds/rti-multiplier/kits/styles.css
// module chunks = 0